<template>
  <div class="component_labels">
    <div class="component_label" :title="item" v-for="(item,index) in labelList" v-if="item && item.length>0 && item !== '[]' && item !== '0'">
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  name: "component_labels",
  props: {
    labelList: Array
  },
}
</script>
<style lang="less">
.component_labels {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  .component_label {
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0 10px;
    border: 1px solid rgba(102, 102, 102, 1);
    border-radius: 10px;
    height: 18px;
    line-height: 18px;
    font-size: 12px;
    color: #666666;
    margin-right: 8px;
    margin-bottom: 8px;
    box-sizing: content-box;
    max-width: 96px;
    overflow-x: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

</style>